export default function () {
  sessionStorage.removeItem('ipgeo');
}
